import { CURRICULUM } from "@/lib/curriculum";

// The visual arc: high-pressure chaos (Adversity) early, calm healing nature (Change) late.
export const MOODS = {
  m1: "Ground", m2: "Adversity", m3: "Adversity", m4: "Adversity",
  m5: "Ground", m6: "Adversity", m7: "Change", m8: "Change",
};

export const MOOD_STYLES = {
  Adversity: "border-red-500/40 text-red-400/90 bg-red-950/30",
  Change: "border-emerald-400/40 text-emerald-300/90 bg-emerald-950/30",
  Ground: "border-[#F59E0B]/40 text-[#B45309] bg-[#F59E0B]/5",
};

export const MOOD_DOT = {
  Adversity: "bg-red-500",
  Change: "bg-emerald-400",
  Ground: "bg-[#F59E0B]",
};

// Mirrors backend/generate_avatar_videos.py JOURNEY: [adversity scene, change scene, dissolve point 0..1]
export const JOURNEY = {
  m1: ["m1", "m5", 0.70],
  m2: ["m2", "m7", 0.78],
  m3: ["m3", "m8", 0.65],
  m4: ["m4", "m7", 0.60],
  m5: ["m6", "m5", 0.50],
  m6: ["m6", "m8", 0.45],
  m7: ["m2", "m7", 0.30],
  m8: ["m4", "m8", 0.18],
};

export const SCENES = {
  m1: "Dark doorway → light-filled corridor",
  m2: "Storm front → sunrise lake",
  m3: "Rain-soaked city → forest light",
  m4: "Crashing waves → still water at dawn",
  m5: "Crowd chaos → light corridor",
  m6: "Crowd chaos → forest light",
  m7: "Storm → sunrise lake",
  m8: "Waves → forest light",
};

export const SCENE_BEDS = {
  m1: "corridor", m2: "storm", m3: "rain_city", m4: "waves",
  m5: "light", m6: "crowd", m7: "dawn_lake", m8: "forest",
};

export const bedFor = (sceneId) => `/audio/beds/${SCENE_BEDS[sceneId] || "light"}.mp3`;

export const posterFor = (id) => `/videos/modules/${id}.jpg`;
export const clipFor = (id) => `/videos/modules/${id}.mp4`;

export const nextModuleId = (completed = []) =>
  CURRICULUM.find((m) => !completed.includes(m.id))?.id || null;

export const changeOpacityFor = (id, progress) => {
  const entry = JOURNEY[id];
  if (!entry) return 0;
  const frac = entry[2];
  return Math.min(1, Math.max(0, (progress - (frac - 0.1)) / 0.2));
};
